module.exports = __webpack_public_path__ + "img/ferratum.4d6c2a6.png";